var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.30583 13.4055L14.705 17.3855M14.6942 6.40551L7.30583 10.3855M20.75 4.89551C20.75 6.55236 19.2949 7.89551 17.5 7.89551C15.7051 7.89551 14.25 6.55236 14.25 4.89551C14.25 3.23865 15.7051 1.89551 17.5 1.89551C19.2949 1.89551 20.75 3.23865 20.75 4.89551ZM7.75 11.8955C7.75 13.5524 6.29493 14.8955 4.5 14.8955C2.70507 14.8955 1.25 13.5524 1.25 11.8955C1.25 10.2387 2.70507 8.89551 4.5 8.89551C6.29493 8.89551 7.75 10.2387 7.75 11.8955ZM20.75 18.8955C20.75 20.5524 19.2949 21.8955 17.5 21.8955C15.7051 21.8955 14.25 20.5524 14.25 18.8955C14.25 17.2387 15.7051 15.8955 17.5 15.8955C19.2949 15.8955 20.75 17.2387 20.75 18.8955Z",
    stroke: "#F5F5F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.6ea6d5b38405ddf8229c3bc4a89be77d.svg";
export { ForwardRef as ReactComponent };